import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
import {
  Stack,
  TextField,
  IconButton,
  InputAdornment,
  Collapse,
  Alert,
  Button
} from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PasswordChecklist from 'react-password-checklist';
import Iconify from 'components/Iconify';
import PropTypes from 'prop-types';
import { ApiUpdatePassword } from 'api';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
// ----------------------------------------------------------------------

// ResetPasswordForm.propTypes = {
//   navigateTo: PropTypes.string
// };

export default function ResetPasswordForm() {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [passwordValid, setPasswordValid] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const MySwal = withReactContent(Swal);
  const user = useSelector((state) => state.userSlice);

  const formik = useFormik({
    initialValues: {
      currentPassword: '',
      password: '',
      confirmation: ''
    },
    onSubmit: async () => {
      ApiUpdatePassword({
        email: user.username,
        oldPassword: currentPassword,
        newPassword: password
      })
        .then(() => {
          setCurrentPassword('');
          setPassword('');
          setConfirmation('');
          MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Your password has been successfully changed!',
            timer: 2000
          });
        })
        .catch(() => {
          MySwal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Wrong credentials. Please verify the email and password used'
          });
        });
    },
    onFailure: (err) => {
      console.error('onFailure', err.message);
    }
  });

  const { handleSubmit, isSubmitting, resetForm } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <TextField
            fullWidth
            type={showCurrentPassword ? 'text' : 'password'}
            label="Current password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={() => setShowCurrentPassword((prev) => !prev)}>
                    <Iconify icon={showCurrentPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          <TextField
            fullWidth
            type={showPassword ? 'text' : 'password'}
            label="New password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={() => setShowPassword((prev) => !prev)}>
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          <TextField
            fullWidth
            type={showConfirmPassword ? 'text' : 'password'}
            label="Confirm new password"
            value={confirmation}
            onChange={(e) => setConfirmation(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton edge="end" onClick={() => setShowConfirmPassword((prev) => !prev)}>
                    <Iconify icon={showConfirmPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          <Collapse in={showAlert}>
            <Alert
              onClose={() => {
                setShowAlert(false);
              }}
              severity="error"
              sx={{ mb: 2 }}
            >
              OTP not correct. Please verify the OTP used
            </Alert>
          </Collapse>
          <PasswordChecklist
            rules={['minLength', 'specialChar', 'number', 'capital', 'match']}
            minLength={8}
            value={password}
            valueAgain={confirmation}
            onChange={(isValid) => {
              setPasswordValid(isValid);
            }}
            iconComponents={{
              ValidIcon: (
                <Iconify icon="akar-icons:circle-check-fill" sx={{ color: '#54d62c', mr: 1 }} />
              ),
              InvalidIcon: (
                <Iconify icon="akar-icons:circle-check" sx={{ color: '#919EAB', mr: 1 }} />
              )
            }}
            messages={{
              minLength: ' Minimum 8 characters.',
              specialChar: ' At least 1 special character.',
              number: ' At least 1 numeral.',
              capital: ' At least 1 capital letter.',
              match: ' Password and confirmation are matching.'
            }}
          />
          <Button
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            disabled={!passwordValid}
          >
            Submit
          </Button>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
